/**
 * 表格中常用的超长省略显示，气泡显示全部，无数据显示“--”
 */
import React from 'react';
import style from './index.module.scss';
import {Tooltip} from 'antd';
import classNames from 'classnames';

interface OverLengthColumnProps {
    value: string;
    width?: number;
    className?: string;
}

export default function OverLengthColumn({
    value,
    width = 120,
    className,
}: OverLengthColumnProps) {
    return (
        <div className={classNames(style.root, className)}>
            <Tooltip title={value} placement={'topLeft'}>
                <span className={style.name} style={{maxWidth: width}}>
                    {value !== '' && value !== null ? value : '--'}
                </span>
            </Tooltip>
        </div>
    );
}
